import {Pipe, PipeTransform} from '@angular/core';
import {TtmTicketDepartmentOptions, TtmTicketTypeOptions} from '../components/ttm-ticket-dialog/ttm-ticket-dialog.component';

@Pipe({
    name: 'TtmTicketDepartment'
})
export class TtmTicketDepartmentPipe implements PipeTransform {
    transform(value: string | null): string {
        if (!value) {
            return 'Nog niet toegewezen';
        }
        return TtmTicketDepartmentOptions[value] || value;
    }
}
